// extracted by mini-css-extract-plugin
export var loadingSpinner = "_5m-1";
export var standaloneTable = "_5m-0";